// extracted by mini-css-extract-plugin
export default {"adminContainer":"AdminWrapper_adminContainer__MY9gF"};